import './App.css';
import {Routes, Route, Navigate } from 'react-router-dom'; // Import necessary components from react-router-dom
import {useEffect } from 'react';
import Header from'./components/header'
import CompaniesVIPSales from './pages/companiesVIPSales'
import JoinUs from './pages/joinUs';
import Ambassadors from './pages/ambassadors'
import Warranty from './pages/warranty'
import './utils/logger'
import brands from './brands.json';


function App() {
  // brand home page 
  const homePage = `https://${brands[process.env.REACT_APP_BRAND].homePage}`;

  const RedirectToExternal = () => {
    useEffect(() => {
      // Redirect to an external URL when the route is accessed
      window.location.href = homePage;
    }, []);
  
    return null; // No need to render anything since it's a redirect
  }; 
  return (
    <div className="App">
      <Header/>
      <Routes> {/* Define your routes within Routes component */}

          <Route path="/joinUS" element={<JoinUs />} /> {/* Define the route for LoginPage */}
          <Route path="/CompaniesVIPSales" element={<CompaniesVIPSales />} /> {/* Define the route for LoginPage */}
          <Route path="/Ambassadors" element={<Ambassadors />} /> {/* Define the route for LoginPage */}
          <Route path="/Warranty" element={<Warranty />} /> {/* Define the route for LoginPage */}

      </Routes>

    </div>
  );
}

export default App;
